export default __webpack_public_path__ + "static/media/shore_ex_banner.52dd903e.webp";